var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHtml5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.77765 28.455L0.282104 0.444458H27.718L25.2224 28.4399L13.9773 31.5556",
    fill: "#E44D26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 29.1737V2.74362H25.2147L23.0746 26.6403",
    fill: "#F16529"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.37903 6.16919H14V9.60245H9.14503L9.46265 13.1189H14V16.5446H6.31675L5.37903 6.16919ZM6.46799 18.2688H9.91638L10.1584 21.0139L14 22.0424V25.6269L6.95198 23.6607",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5906 6.16919H13.9847V9.60245H22.273L22.5906 6.16919ZM21.9629 13.1189H13.9847V16.5522H18.2196L17.8188 21.0139L13.9847 22.0424V25.6117L21.0176 23.6607",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml5);
export default __webpack_public_path__ + "static/media/html5.92cd34f7ba24c6182190c97964af12b0.svg";
export { ForwardRef as ReactComponent };